import React, { FC } from "react";
import { Card, CardContent, CardHeader, Container, Divider, Grid, Paper, FormControlLabel, Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import store from "./store";
import { observer } from "mobx-react";
import LookUp from "components/LookUp";
import CustomTextField from "components/TextField";
import CustomCheckbox from "components/Checkbox";
import DateTimeField from "components/DateTimeField";
import FileField from "components/FileField";

type OutgoingDocumentTableProps = {
  children?: React.ReactNode;
  isPopup?: boolean;
};

const OutgoingDocumentAddEditBaseView: FC<OutgoingDocumentTableProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;
  
  return (
    <Container maxWidth='xl' sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        <Grid item md={props.isPopup ? 12 : 6}>
          <form data-testid="outgoingDocumentForm" id="outgoingDocumentForm" autoComplete='off'>
            <Card component={Paper} elevation={5}>
              <CardHeader title={
                <span id="outgoing_document_TitleName">
                  {translate('label:outgoingDocumentAddEditView.entityTitle')}
                </span>
              } />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  
                  {/* <Grid item md={12} xs={12}>
                    <LookUp
                      value={store.incoming_document_id}
                      onChange={(event) => store.handleChange(event)}
                      name="incoming_document_id"
                      data={store.incoming_documents}
                      id="id_f_outgoing_document_incoming_document_id"
                      label={translate("label:outgoingDocumentAddEditView.incoming_document_id")}
                      helperText={store.errors.incoming_document_id}
                      error={!!store.errors.incoming_document_id}
                    />
                  </Grid> */}

                  <Grid item md={12} xs={12}>
                    <LookUp
                      value={store.document_type_id}
                      onChange={(event) => store.handleChange(event)}
                      name="document_type_id"
                      data={store.document_types}
                      id="id_f_outgoing_document_document_type_id"
                      label={translate("label:outgoingDocumentAddEditView.document_type_id")}
                      helperText={store.errors.document_type_id}
                      error={!!store.errors.document_type_id}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.name}
                      onChange={(event) => store.handleChange(event)}
                      name="name"
                      data-testid="id_f_outgoing_document_name"
                      id='id_f_outgoing_document_name'
                      label={translate('label:outgoingDocumentAddEditView.name')}
                      helperText={store.errors.name}
                      error={!!store.errors.name}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <FileField
                      value={store.file_name}
                      helperText={store.errors.file_name}
                      error={!!store.errors.file_name}
                      inputKey={store.idDocumentInputKey}
                      fieldName="file_name"
                      onChange={(event) => {
                        if (event.target.files.length === 0) return;
                        store.handleChange({ target: { value: event.target.files[0], name: "File" } });
                        store.handleChange({ target: { value: event.target.files[0].name, name: "file_name" } });
                      }}
                      onClear={() => {
                        store.handleChange({ target: { value: null, name: "File" } });
                        store.handleChange({ target: { value: '', name: "file_name" } });
                        store.changeDocInputKey();
                      }}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.document_number}
                      onChange={(event) => store.handleChange(event)}
                      name="document_number"
                      data-testid="id_f_outgoing_document_document_number"
                      id='id_f_outgoing_document_document_number'
                      label={translate('label:outgoingDocumentAddEditView.document_number')}
                      InputProps={
                        store.id === 0 && !!store.docNextNumber && !store.docNumberManual
                          ? { readOnly: true }
                          : undefined
                      }
                      helperText={store.errors.document_number}
                      error={!!store.errors.document_number}
                    />
                    {store.id === 0 && !!store.docNextNumber && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={store.docNumberManual}
                            onChange={() => store.toggleDocNumberManual()}
                            size="small"
                          />
                        }
                        label="Ввести вручную"
                        sx={{ mt: 0.5 }}
                      />
                    )}
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <DateTimeField
                      value={store.document_date}
                      disabled
                      onChange={(event) => store.handleChange(event)}
                      name="document_date"
                      id='id_f_outgoing_document_document_date'
                      label={translate('label:outgoingDocumentAddEditView.document_date')}
                      helperText={store.errors.document_date}
                      error={!!store.errors.document_date}
                    />
                  </Grid>

                  {/* version скрыт */}

                  {/* <Grid item md={12} xs={12}>
                    <LookUp
                      value={store.prepared_by}
                      onChange={(event) => store.handleChange(event)}
                      name="prepared_by"
                      data={store.users}
                      id="id_f_outgoing_document_prepared_by"
                      label={translate("label:outgoingDocumentAddEditView.prepared_by")}
                      helperText={store.errors.prepared_by}
                      error={!!store.errors.prepared_by}
                    />
                  </Grid> */}

                  {/* <Grid item md={12} xs={12}>
                    <DateTimeField
                      value={store.prepared_at}
                      onChange={(event) => store.handleChange(event)}
                      name="prepared_at"
                      id='id_f_outgoing_document_prepared_at'
                      label={translate('label:outgoingDocumentAddEditView.prepared_at')}
                      helperText={store.errors.prepared_at}
                      error={!!store.errors.prepared_at}
                    />
                  </Grid> */}

                  {/* <Grid item md={12} xs={12}>
                    <LookUp
                      value={store.signed_by}
                      onChange={(event) => store.handleChange(event)}
                      name="signed_by"
                      data={store.users}
                      id="id_f_outgoing_document_signed_by"
                      label={translate("label:outgoingDocumentAddEditView.signed_by")}
                      helperText={store.errors.signed_by}
                      error={!!store.errors.signed_by}
                    />
                  </Grid> */}

                  {/* <Grid item md={12} xs={12}>
                    <DateTimeField
                      value={store.signed_at}
                      onChange={(event) => store.handleChange(event)}
                      name="signed_at"
                      id='id_f_outgoing_document_signed_at'
                      label={translate('label:outgoingDocumentAddEditView.signed_at')}
                      helperText={store.errors.signed_at}
                      error={!!store.errors.signed_at}
                    />
                  </Grid> */}

                  {/* is_final скрыт */}

                  {/* <Grid item md={12} xs={12}>
                    <CustomCheckbox
                      value={store.sent_to_bga}
                      onChange={(event) => store.handleChange(event)}
                      name="sent_to_bga"
                      label={translate('label:outgoingDocumentAddEditView.sent_to_bga')}
                      id='id_f_outgoing_document_sent_to_bga'
                    />
                  </Grid> */}

                  {/* <Grid item md={12} xs={12}>
                    <DateTimeField
                      value={store.sent_at}
                      onChange={(event) => store.handleChange(event)}
                      name="sent_at"
                      id='id_f_outgoing_document_sent_at'
                      label={translate('label:outgoingDocumentAddEditView.sent_at')}
                      helperText={store.errors.sent_at}
                      error={!!store.errors.sent_at}
                    />
                  </Grid> */}

                </Grid>
              </CardContent>
            </Card>
          </form>
        </Grid>
        {props.children}
      </Grid>
    </Container>
  );
})

export default OutgoingDocumentAddEditBaseView;